// extracted by mini-css-extract-plugin
module.exports = {"popContent":"styles_popContent__23Ods","imgBox":"styles_imgBox__1MsOF","describe":"styles_describe__1QWjI"};